export type BonusSheetSearch = {
  bonus?: string
  redeem?: number
  partnerId?: number
}

export const parseBonusSheetFromQuery = (
  query: Record<string, unknown>
): BonusSheetSearch => {
  const partnerIdRaw = query.partnerId
  const partnerId =
    typeof partnerIdRaw === 'string' && partnerIdRaw
      ? Number(partnerIdRaw)
      : typeof partnerIdRaw === 'number'
        ? partnerIdRaw
        : undefined

  return {
    bonus: typeof query.bonus === 'string' ? query.bonus : undefined,
    redeem: Number(query.redeem) === 1 ? 1 : undefined,
    partnerId: Number.isFinite(partnerId) ? partnerId : undefined
  }
}

export const validateBonusSheetSearch = (
  search: Record<string, unknown>
): BonusSheetSearch => parseBonusSheetFromQuery(search)

export const isBonusSheetSearchActive = (search: BonusSheetSearch) =>
  Boolean(search.bonus) && search.redeem === 1

export const clearBonusSheetSearch = (): BonusSheetSearch => ({
  bonus: undefined,
  redeem: undefined,
  partnerId: undefined
})

export const buildBonusSheetHref = (
  pathname: string,
  uid: string,
  partnerId?: number | null
) => {
  const params = new URLSearchParams({ bonus: uid, redeem: '1' })

  if (partnerId != null) {
    params.set('partnerId', String(partnerId))
  }

  return `${pathname}?${params.toString()}`
}

export const buildBonusSheetClearHref = (
  pathname: string,
  query: Record<string, string | string[] | undefined>
) => {
  const params = new URLSearchParams()

  for (const [key, value] of Object.entries(query)) {
    if (key === 'bonus' || key === 'redeem' || key === 'partnerId') continue
    if (typeof value === 'string' && value) params.set(key, value)
  }

  const qs = params.toString()
  return qs ? `${pathname}?${qs}` : pathname
}

/** @deprecated Prefer `buildBonusSheetHref(pathname, uid)` — sheet é global na rota atual. */
export const buildBonusRedeemHref = (uid: string, partnerId?: number | null) =>
  buildBonusSheetHref('/bonus', uid, partnerId)
